import { createContext, useContext, useEffect, useRef, useState } from "react";
import { api, getSessionId, setSessionId } from "@/lib/api";

const SessionContext = createContext(null);

export function SessionProvider({ children }) {
  const [sessionId, setSessionIdState] = useState(getSessionId());
  const [ready, setReady] = useState(false);
  const initInFlight = useRef(false);

  useEffect(() => {
    if (initInFlight.current) return;
    initInFlight.current = true;
    const init = async () => {
      try {
        const { data } = await api.post("/session/start", { existing_session_id: getSessionId() });
        setSessionId(data.anonymous_session_id);
        setSessionIdState(data.anonymous_session_id);
      } catch (e) {
        console.error("Failed to start session", e);
      } finally {
        setReady(true);
      }
    };
    init();
  }, []);

  return (
    <SessionContext.Provider value={{ sessionId, ready }}>
      {children}
    </SessionContext.Provider>
  );
}

export const useSession = () => useContext(SessionContext);
